import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const apiProtocol = window.location.protocol === 'https:' ? 'https' : 'http';
const apiHost     = window.location.protocol === 'https:' ? 'api.imolgaro.com' : '127.0.0.1';
const apiPort     = '42505';

const apiClient = axios.create({
    baseURL: `${apiProtocol}://${apiHost}:${apiPort}`,
    // headers: {
    //     'Content-Type': 'application/json',
    // },
});


// HELPER DE TOKEN
const getToken = () => localStorage.getItem('jwtToken');
const removeToken = () => localStorage.removeItem('jwtToken');
const setToken = (token) => localStorage.setItem('jwtToken', token);


// VERIFICAR VALIDADE DO TOKEN
const isTokenValid = () => {
    const token = getToken();
    if (!token) return false;

    try{
        const decodedToken = jwtDecode(token);
        const now = Date.now();
        return decodedToken.exp * 1000 > now;
    } catch(error){
        console.error('Erro ao decodificar o token:', error);
        return false;
    }
};

apiClient.interceptors.request.use((config) => {
    if (config.skipAuth) return config;

    if (!isTokenValid()){
        /// quando vier de loginAPI deve ignorar validação
        removeToken();
        // TODO: REDIRECIONAR PARA TELA DE LOGIN::: EXEMPLO::: window.location.href = '/login';
        return Promise.reject(new Error('Token expirado'));
    }

    const token = getToken();
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error))


async function genericDelete(nmentidade, id, idusuario) {
    const response = await apiClient.delete(`/cad/generic`, { params: { nmentidade, id, idusuario } });
    return response.data;
}


async function genericGet(endpoint, params = {}) {
    const response = await apiClient.get(endpoint, {params: params});
    return response.data;
}


async function genericPost(endpoint, dados) {
    const response = await apiClient.post(endpoint, dados);
    return response.data;
}


// POST FORMDATA
async function genericPostFormData(endpoint, file, fieldName = 'arquivo') {
    const formData = new FormData();
    formData.append(fieldName, file, file.name);

    const response = await apiClient.post(endpoint, formData, {
        transformRequest: [(data) => data],
    });

    return response.data;
}


async function genericPut(endpoint, dados) {
    const response = await apiClient.put(endpoint, dados);
    return response.data;
}


async function genericReport(dados) {
    const response = await apiClient.post('/main/relatorio', dados, {responseType: 'blob'});
    return response.data;
}


async function genericReportFixed(dados) {
    // RELATÓRIOS FIXADOS POR DATAMODULE - AGUARDAR MIGRAÇÃO PARA NOVO PADRÃO
    const response = await apiClient.post('/report/diversos', dados, {responseType: 'blob'});
    return response.data;
}


async function getBoletoPdf(idboleto) {
    const response = await apiClient.get('/cobranca_api/boleto', {params: {idboleto}, responseType: 'blob'});
    return response.data;
}


async function getCarneBoletoPdf(idcobranca) {
    const response = await apiClient.get('/cobranca_api/carne/boletos', {params: {idcobranca}, responseType: 'blob'});
    return response.data;
}


async function getCadastroById(nmcadastro, id) {
    const response = await apiClient.get(`/cad/${ nmcadastro }`, { params: { id } });
    return response.data;
}


async function loginAPI(userName, passWord, dados = {}) {
    const headers = {
        'Content-Type': 'application/json',
        'jwtusername': userName,
        'jwtpassword': passWord
    };
    removeToken(); // GARANTIR NÃO TER MAIS TOKEN ATIVO

    try{
        const response = await apiClient.post('/login', dados, { headers, skipAuth: true, });
        if (response.data.token){
            setToken(response.data.token);
            return true;
      }else{return false;}
    } catch (error){
        console.error('Erro durante o login:', error);
        return false;
    }
}

async function loginDisponivel(idCadastro, loginName) {
    try{
        const resp = await apiClient.post('/cad/login_disponivel', { id: idCadastro, nmpesquisar: loginName });
        return (resp.data.bolok == 1) ? true : false;
    }catch{
        return false;
    }
}

function logoutAPI() {
    removeToken();
    // TODO: REDIRECIONAR PARA TELA DE LOGIN::: EXEMPLO::: window.location.href = '/login';
}

export const Api = {
    genericDelete,
    genericGet,
    genericPost,
    genericPostFormData,
    genericPut,
    genericReport,
    genericReportFixed,
    getBoletoPdf,
    getCarneBoletoPdf,
    getCadastroById,
    loginAPI,
    loginDisponivel,
    logoutAPI
}